import o from "./contact-channels62.js";
import i from "./contact-channels63.js";
import d from "./contact-channels64.js";
import r from "./contact-channels65.js";
const f = {
  // Validate subject format
  validateSubject: function(t) {
    const n = /[<>$+*/&\\~.#{|^@()[\]}%=!:;£?"]/;
    return t !== void 0 && !o(t) && !n.test(t);
  },
  // Validate issue format
  validateIssue: function(t) {
    const n = /[<>$+*/&\\~.#{|^@()[\]}%=!:;£?"]/;
    return t !== void 0 && !o(t) && !n.test(t);
  },
  // Validate order number format
  validateOrderNumber: function(t) {
    const n = /[<>$+*/&\\~.#{|^@()[\]}%=!:;£?"]/;
    return t === void 0 || t !== void 0 && o(i(t)) || t !== void 0 && !o(i(t)) && !n.test(i(t));
  },
  // Validate phone number format
  validatePhoneNumber: function(t) {
    const n = /^[+]{0,1}[0-9]{1,19}$/;
    return t === void 0 || t !== void 0 && o(i(t)) || t !== void 0 && !o(i(t)) && n.test(i(t));
  },
  // Validate name format
  validateNameEmpty: function(t) {
    return t !== void 0 && !o(i(t));
  },
  // Validate name format
  validateNameFormat: function(t) {
    return t !== void 0 && !/[<>$+*/&\\~.#{|^@()[\]}%=!:;£?"]/.test(i(t)) && d(i(t), { min: 1, max: 30 });
  },
  // Validate email address empty
  validateEmailAddressEmpty: function(t) {
    return t !== void 0 && !o(i(t));
  },
  // Validate email existing @
  validateEmailExistingAt: function(t) {
    return t !== void 0 && i(t).includes("@");
  },
  // Validate email address
  validateEmailAddress: function(t) {
    return t !== void 0 && r(i(t));
  },
  // Validate company format
  validateCompany: function(t) {
    const n = /[<>"]/;
    return t === void 0 || t !== void 0 && o(i(t)) || t !== void 0 && !o(i(t)) && !n.test(i(t));
  },
  // Validate comment empty
  validateCommentEmpty: function(t) {
    return t !== void 0 && d(i(t), { min: 1 });
  },
  // Validate comment format
  validateCommentFormat: function(t) {
    const n = /[<>"]/;
    return t !== void 0 && !o(i(t)) && !n.test(i(t));
  }
};
export {
  f as default
};
//# sourceMappingURL=contact-channels15.js.map
